import { getGridDateOperators, getGridNumericOperators, getGridStringOperators } from "@mui/x-data-grid-pro";

/// <summary>
/// Numeric filter operators for DataGridPro.
/// Removes unnecessary operators such as:
/// - "isAnyOf"
/// - "isEmpty"
/// - "isNotEmpty"
/// </summary>
export const numericOperators = getGridNumericOperators().filter(
    (operator) =>
        operator.value !== "isAnyOf" &&
        operator.value !== "isEmpty" &&
        operator.value !== "isNotEmpty"
);

/// <summary>
/// String filter operators for DataGridPro.
/// Removes unnecessary operators such as:
/// - "isAnyOf"
/// - "isEmpty"
/// - "isNotEmpty"
/// </summary>
export const stringOperators = getGridStringOperators().filter(
    (operator) =>
        operator.value !== "isAnyOf" &&
        operator.value !== "isEmpty" &&
        operator.value !== "isNotEmpty"
);

/// <summary>
/// Date filter operators for DataGridPro.
/// Removes unnecessary operators such as:
/// - "isEmpty"
/// - "isNotEmpty"
/// - "not"
/// </summary>
export const dateOperators = getGridDateOperators().filter(
    (operator) =>
        operator.value !== "isEmpty" &&
        operator.value !== "isNotEmpty" &&
        operator.value !== "not"
);

/**
 * Maps symbolic filter operators to WAF-safe word equivalents.
 * Symbolic operators like ">=", "!=", "<" trigger Azure WAF SQLI rules
 * (e.g., 942120) when sent as JSON values in the request payload.
 */
const NUMERIC_OPERATOR_MAP: Record<string, string> = {
    '=': 'equals',
    '!=': 'notEquals',
    '>': 'greaterThan',
    '<': 'lessThan',
    '>=': 'greaterThanOrEqual',
    '<=': 'lessThanOrEqual',
};

/**
 * Converts a symbolic filter operator to its WAF-safe word equivalent.
 * Returns the original operator unchanged if no mapping exists
 * (e.g., "contains", "startsWith" pass through as-is).
 *
 * @param op - The filter operator from MUI DataGrid (e.g., ">=", "contains").
 * @returns The WAF-safe operator string (e.g., "greaterThanOrEqual", "contains").
 */
export const sanitizeOperator = (op: string): string => NUMERIC_OPERATOR_MAP[op] || op;